const API_BASE = '/api';

// Fetch CSRF token
async function fetchCsrfToken() {
  const response = await fetch(`${API_BASE}/csrf/`, {
    credentials: 'include',
  });
  const data = await response.json();
  return data.csrfToken;
}

// Admin login
export async function adminLogin(username, password) {
  const csrfToken = await fetchCsrfToken();

  const response = await fetch(`${API_BASE}/admin/login/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    credentials: 'include',
    body: JSON.stringify({ username, password }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Login failed');
  }

  return data;
}

// Admin logout
export async function adminLogout() {
  const csrfToken = await fetchCsrfToken();

  const response = await fetch(`${API_BASE}/admin/logout/`, {
    method: 'POST',
    headers: {
      'X-CSRFToken': csrfToken,
    },
    credentials: 'include',
  });

  return response.json();
}

// Check authentication status
export async function checkAuth() {
  const response = await fetch(`${API_BASE}/admin/check-auth/`, {
    credentials: 'include',
  });
  return response.json();
}

// Get dashboard stats
export async function getDashboardStats() {
  const response = await fetch(`${API_BASE}/admin/dashboard/stats/`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch stats');
  }

  return response.json();
}

// Get all subcontractors
export async function getSubcontractors() {
  const response = await fetch(`${API_BASE}/admin/subcontractors/`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch subcontractors');
  }

  return response.json();
}

// Update subcontractor status
export async function updateSubcontractor(id, data) {
  const csrfToken = await fetchCsrfToken();

  const response = await fetch(`${API_BASE}/admin/subcontractors/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Failed to update subcontractor');
  }

  return response.json();
}

// Get all companies
export async function getCompanies() {
  const response = await fetch(`${API_BASE}/admin/companies/`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch companies');
  }

  return response.json();
}

// Update company status
export async function updateCompany(id, data) {
  const csrfToken = await fetchCsrfToken();

  const response = await fetch(`${API_BASE}/admin/companies/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Failed to update company');
  }

  return response.json();
}

// Get all messages
export async function getMessages() {
  const response = await fetch(`${API_BASE}/admin/messages/`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch messages');
  }

  return response.json();
}

// Update message
export async function updateMessage(id, data) {
  const csrfToken = await fetchCsrfToken();

  const response = await fetch(`${API_BASE}/admin/messages/${id}/`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Failed to update message');
  }

  return response.json();
}
